import { ShieldCheck, Users, MapPin, Award } from "lucide-react";
import { PHOTOS } from "@/lib/site";

const POINTS = [
  { icon: Users, title: "Squadra reale", desc: "Operatori formati, identificabili, con la divisa Sicilia Traslochi." },
  { icon: ShieldCheck, title: "Assicurati al 100%", desc: "Ogni intervento coperto da assicurazione completa." },
  { icon: MapPin, title: "Radici siciliane", desc: "Caltanissetta è la nostra base. La Sicilia è la nostra casa." },
  { icon: Award, title: "18+ anni di mestiere", desc: "Migliaia di famiglie e aziende ci hanno scelto. E riscelto." },
];

export default function Team() {
  return (
    <section
      data-testid="team-section"
      className="relative py-24 lg:py-32 bg-white overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* IMAGE */}
          <div className="lg:col-span-7 reveal">
            <div className="relative rounded-3xl overflow-hidden border border-brand-line shadow-brand">
              <img
                src={PHOTOS.team}
                alt="Il team Sicilia Traslochi davanti al furgone aziendale a Caltanissetta"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-brand-ink/85 via-brand-ink/30 to-transparent p-6 lg:p-8">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/95 text-brand-primary text-[10px] uppercase tracking-[0.2em] font-bold mb-3">
                  Il nostro team
                </div>
                <div className="font-display font-extrabold text-2xl lg:text-3xl text-white tracking-tight">
                  Persone reali. Mezzi reali. Risultati reali.
                </div>
              </div>
            </div>

            {/* Floating stat badge */}
            <div className="hidden lg:flex absolute -mt-12 ml-6 items-center gap-3 px-5 py-3 rounded-2xl bg-white border border-brand-line shadow-brand">
              <div className="w-10 h-10 rounded-xl bg-brand-primary text-white flex items-center justify-center">
                <Users className="w-5 h-5" />
              </div>
              <div>
                <div className="font-display font-extrabold text-xl text-brand-ink leading-none">12+</div>
                <div className="text-[10px] uppercase tracking-[0.18em] text-brand-body mt-0.5">Operatori formati</div>
              </div>
            </div>
          </div>

          {/* TEXT */}
          <div className="lg:col-span-5 lg:pl-6">
            <div className="reveal">
              <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-bold text-brand-primary">
                <span className="w-8 h-px bg-brand-primary" />
                Chi siamo
              </div>
              <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-brand-ink mt-4 text-balance">
                Una famiglia<br />
                <span className="text-brand-primary">al servizio</span><br />
                della vostra.
              </h2>
              <p className="mt-6 text-lg text-brand-body leading-relaxed">
                Non siamo un'agenzia che subappalta. Siamo <strong className="text-brand-ink">la squadra</strong> che troverete a casa vostra:
                stessi volti, stessa cura, stessa firma sul contratto.
              </p>
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {POINTS.map(({ icon: Icon, title, desc }, i) => (
                <div
                  key={title}
                  data-testid={`team-point-${i}`}
                  className={`p-5 rounded-2xl border border-brand-line hover:border-brand-primary transition-colors reveal reveal-delay-${(i % 4) + 1}`}
                >
                  <div className="w-9 h-9 rounded-lg bg-brand-primary/10 text-brand-primary flex items-center justify-center">
                    <Icon className="w-5 h-5" />
                  </div>
                  <div className="mt-3 font-display font-bold text-brand-ink">{title}</div>
                  <div className="text-sm text-brand-body mt-1 leading-relaxed">{desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
